import { render, staticRenderFns } from "./NewRirekishoExampleSentenceDialog.vue?vue&type=template&id=d77d92ac"
import script from "./NewRirekishoExampleSentenceDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewRirekishoExampleSentenceDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewRirekishoExampleSentenceDialog.vue?vue&type=style&index=0&id=d77d92ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports